import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import cn from 'classnames';
import _ from 'lodash';

import { buildSourceURL } from '../../utils/functions';
import PageWithHeader from '../../components/PageWithHeader/PageWithHeader';
import { getBasketProducts } from '../../actions/product';
import config from '../../config';

import styles from './BasketProducts.module.css';

const BasketProducts = (props) => {
  const { 
    getBasketProducts, 
    initProducts,
    userData,
  } = props;

  console.log('===userData', userData);

  const storeData = useParams().store;
  const [products, setProducts] = useState([]);
  // const [totalPrice, setTotalPrice] = useState(0);
  // const [completedProducts, setCompletedProducts] = useState({});

  useEffect(() => {
    getBasketProducts(storeData);
  }, []);

  // useEffect(() => {
  //   let totalPrice = 0;
    
  //   products.forEach((product) => {
  //     totalPrice += product.price_pro_unit * product.sale_amount;
  //   }, 0);
  
  //   setTotalPrice(totalPrice);
  // }, [products]);

  useEffect(() => {
    if (initProducts?.basket?.length) {
      setProducts(initProducts?.basket);
    }
  }, [initProducts]);

  // console.log('===storeData', products);

  const getProductIndexById = (productId) => {
    return products.findIndex((product) => product.id === productId);
  };

  // const onSelectHandler = (productId) => {
  //   const productIndex = getProductIndexById(productId);
  //   products[productIndex].selected = !products[productIndex].selected;
  //   setProducts([...products]);
  // };

  const onChangeAmountHandler = (event, productId, amount) => {
    event.stopPropagation();
    const productIndex = getProductIndexById(productId);

    const newAmount = products[productIndex].sale_amount + amount;
    if (newAmount < 0) {
      return;
    }

    products[productIndex].sale_amount = newAmount;
    setProducts([...products]);
  };

  if (_.isEmpty(initProducts)) {
    return null;
  }
  
  const renderStoreBlock = () => {
    return (
      <div className={styles.leftContent}>
        <div className={styles.storeInfo}>
          <div className={styles.storeMainInfo}>
            <div className={styles.storeName}>
              Basket
            </div>
          </div>
        </div>
        <div className={styles.productsCommonData}>
          <div className={styles.productsCommonItem}>
            <div className={styles.mealsIcon} />
            <div className={styles.commonItemText}>
              <div className={styles.commonItemAmount}>
                {initProducts.meals}
              </div>
              <div className={styles.commonItemUnit}>
                Meals
              </div>
            </div>
          </div>
          <div className={styles.productsCommonItem}>
            <div className={styles.ingredientsIcon} />
            <div className={styles.commonItemText}>
              <div className={styles.commonItemAmount}>
                {initProducts.ingredients}
              </div>
              <div className={styles.commonItemUnit}>
                Ingredients
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderImage = (product) => {
    if (!product.image) {
      return (
        <div className={styles.noImage} />
      );
    }

    const imageURL = product.image.startsWith('http')
      ? product.image
      : buildSourceURL(product.image);

    return (
      <img 
        className={styles.productImage}
        src={imageURL} 
        alt={product.name} 
      />
    );
  };

  return (
    <PageWithHeader>
      <div className={styles.wrapper}>
        <div className={styles.title}>
          Select groceries
        </div>
        <div className={styles.content}>
          {renderStoreBlock()}
          <div className={styles.centerContent}>
            {products.map((product) => (
              <div 
                // data={console.log('===product', product)}
                key={product.id} 
                className={cn(styles.productItem, {[styles.selected]: product.selected} )}
                // onClick={() => onSelectHandler(product.id)}
              >
                {renderImage(product)}
                <div className={styles.productInfo}>
                  <div className={styles.productName}>
                    {product.name}
                  </div>
                  {/* <div className={styles.productPrice}>
                    £ {product.price_pro_unit.toFixed(2)}
                  </div> */}
                  <div className={styles.productAmountBlock}>
                    <div 
                      className={styles.productMinus} 
                      onClick={(event) => onChangeAmountHandler(event, product.id, -1)} 
                    />
                    <div className={styles.productAmount}>
                      {product.sale_amount}
                    </div>
                    <div 
                      className={styles.productPlus} 
                      onClick={(event) => onChangeAmountHandler(event, product.id, 1)} 
                    />
                    {/* {completedProducts[product.id] && (
                      <div className={styles.complete}>
                        ✔
                      </div>
                    )} */}
                  </div> 
                </div>
                {/* <div
                  className={cn('green-button', styles.buyButton)}
                  onClick={() => setCompletedProducts(completedProducts => ({ ...completedProducts, [product.id]: true }))}
                >
                  Buy
                </div> */}
              </div>
            ))}
          </div>
          <div className={styles.bottomButtons}>
            <a
              className={cn('green-button', styles.downloadButton)}
              target="_blank"
              rel="noreferrer"
              href={`${config.pdfURL}?user_id=${userData.id}`}
            >
              Download shopping list
            </a>
          </div>
        </div>
      </div>
    </PageWithHeader>
  );
};

const mapStateToProps = (state) => ({
  initProducts: state.product.basketProductsData,
  userData: state.auth.userData.user,
});

const mapDispatchToProps = {
  getBasketProducts,
};

export default connect(mapStateToProps, mapDispatchToProps)(BasketProducts);